const BLOCKED_TAGS = new Set(['INPUT', 'TEXTAREA', 'SELECT'])

export const ARROW_NUDGE_KEYS = new Set([
  'arrowup',
  'arrowdown',
  'arrowleft',
  'arrowright',
  'shift+arrowup',
  'shift+arrowdown',
  'shift+arrowleft',
  'shift+arrowright'
])

const ARROW_CODE_TO_KEY = {
  ArrowUp: 'arrowup',
  ArrowDown: 'arrowdown',
  ArrowLeft: 'arrowleft',
  ArrowRight: 'arrowright'
}

/**
 * @param {EventTarget|null} target
 * @returns {boolean}
 */
export function isEditorTextInputTarget (target) {
  if (!target || !(target instanceof Element)) {
    return false
  }

  let el = target
  while (el.shadowRoot?.activeElement) {
    el = el.shadowRoot.activeElement
  }

  if (el.isContentEditable) {
    return true
  }

  const root = el.getRootNode()
  if (root instanceof ShadowRoot) {
    const active = root.activeElement
    if (active instanceof Element && BLOCKED_TAGS.has(active.nodeName)) {
      return true
    }
    if (root.host instanceof Element) {
      el = root.host
    }
  }

  return BLOCKED_TAGS.has(el.nodeName)
}

/**
 * @param {KeyboardEvent} e
 * @returns {string|null}
 */
export function normalizeArrowNudgeKey (e) {
  const arrowKey = ARROW_CODE_TO_KEY[e.code] || e.key.toLowerCase()
  if (!arrowKey.startsWith('arrow')) {
    return null
  }
  return `${e.shiftKey ? 'shift+' : ''}${arrowKey}`
}

/**
 * Returns true when editor-wide keyboard shortcuts (arrows, copy/paste, etc.)
 * should run for the given event target.
 * @param {EventTarget|null} target
 * @returns {boolean}
 */
export function shouldHandleEditorShortcut (target) {
  if (!target || !(target instanceof Element)) {
    return false
  }

  if (isEditorTextInputTarget(target)) {
    return false
  }

  if (target === document.body) {
    return true
  }

  const workarea = document.getElementById('workarea')
  if (workarea && (target === workarea || workarea.contains(target))) {
    return true
  }

  return false
}
